import axios from "../network/reuset";
import qs from "qs";

const getBill = {
  getBillList(params) {
    return axios.post(`/api/admin/bill/list`, qs.stringify(params));
  },
};

export default getBill;
